import React from 'react';
import { Table } from 'reactstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import moment from 'moment';
import { formatNumber } from '../../../Utils/Money';

const RowsData = ({ data, headers }) => {
    return headers.map((header, index) => <td key={index} style={{ maxWidth: '100px', height: '1em', padding: 0 }} >{data[header.accesor]}</td>)
}

const Header = ({ headers }) => {
    return headers.map((header, index) => <th key={index} style={{ maxWidth: '100px', padding: 3 }}>{header.Header}</th>)
}


const ElementInvoice = ({ item, index, invoiceChecks, setInvoiceChecks }) => {

    const headers = [
        {
            Header: "N° Recibo",
            accesor: "num_recibo"
        },
        {
            Header: "Admision",
            accesor: "id_admision"
        },
        {
            Header: "Fecha",
            accesor: "fecha"
        },
        {
            Header: "Moneda",
            accesor: "moneda"
        },
        {
            Header: "Tipo de pago",
            accesor: "tipo_pago"
        }
    ]

    item.fecha = moment(item.fecha).format("YYYY/MM/DD");

    return (<div style={{ border: 'solid gray 1px', width: '100%', margin: '0.25em 0em', padding: '0em 1em', borderRadius: '0.25em' }}>
        <div className='flex-row' style={{justifyContent: 'flex-start', margin: '0.25em 0em'}}>
            <div style={{ paddingRight: 10 }}>Datos Paciente</div>
            <div style={{ paddingRight: 10 }}>{`${item.tip_documento} ${item.num_documento}`}</div>
            <div style={{ paddingRight: 10 }}>{`${item.nombres} ${item.apellido1} ${item.apellido2}`}</div>
        </div>
        <Table responsive hover>
            <thead>
                <tr>
                    <Header headers={headers} />
                    <th style={{ maxWidth: '100px', padding: 3 }}>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr key={item.id}>
                    <RowsData data={item} headers={headers} />
                    <td style={{ maxWidth: '100px', height: '1em', padding: 0 }} >
                        <FormControlLabel
                            key={index}
                            control={
                                <Checkbox
                                    checked={invoiceChecks[index]}
                                    size='small'
                                    onChange={() => {
                                        let NewChecks = [...invoiceChecks];
                                        NewChecks[index] = !NewChecks[index];
                                        setInvoiceChecks(NewChecks);
                                    }}
                                    //defaultChecked={true}
                                    name={"check-item"}
                                    color="primary"
                                />
                            }
                            label={""}
                        />
                    </td>
                </tr>
            </tbody>
        </Table>
        <div className='flex-row' style={{justifyContent: 'flex-start', margin: '0.25em 0em'}}>
            <div style={{ paddingRight: 10 }}><b>Copago: </b>${formatNumber(parseInt(item.total))}</div>
            <div style={{ paddingRight: 10 }}><b>Total: </b>${formatNumber(parseInt(item.valor_tercero))} </div>
            <div style={{ paddingRight: 10 }}><b>Subtotal: </b>${formatNumber(parseInt(item.subtotal))}</div>
        </div>

    </div>)
}

export default React.memo(ElementInvoice);